import { dateStringToYear } from "utils/date";

import type { HeatingKey } from "../model/types";

import { EpcExtractionData } from "../components/address-step/epc-modal/types";
import { HEATING_KEYS } from "../components/details-step/constants";
import { convertBuildingTypeArrayToFormData } from "./mixConfiguration";

const parseInstallationYear = (value: unknown): number | undefined => {
  if (typeof value !== "string") return undefined;
  return dateStringToYear(value);
};

export const getEpcAutofillValues = (epcData: EpcExtractionData) => {
  const suggested = epcData?.suggestedFields;

  const heatingSystem = HEATING_KEYS.includes(suggested?.heatingSystem as HeatingKey)
    ? suggested?.heatingSystem
    : undefined;

  return {
    addressInfo: {
      address: suggested?.street,
      city: suggested?.city,
      country: suggested?.country,
      postal_code: suggested?.postCode,
    },
    buildingType: convertBuildingTypeArrayToFormData(suggested?.buildingType),
    constructionYear: suggested?.constructionYear ?? undefined,
    footprintArea: suggested?.footprintArea ?? undefined,
    heating_system: heatingSystem,
    installation_date: parseInstallationYear(suggested?.heatingSystemInstalledAt),
    mechanical_ventilation: suggested?.mechanicalVentilation,
    rentalUnits: suggested?.rentalUnits ?? undefined,
  };
};
